export default __webpack_public_path__ + "static/media/comic2_1.477d2de6.png";